export const decodeHTMLEntities = (text: string): string => {
  const entities: { [key: string]: string } = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#039;': "'",
    '&nbsp;': ' '
  };

  return text.replace(
    /&amp;|&lt;|&gt;|&quot;|&#039;|&nbsp;/g,
    (match) => entities[match]
  );
};
